/* eslint-disable no-unused-vars */
import store from "../store/index";
import HttpService from '@/utils/httpService';

export function getDocumentStorageReference(document) {

    if (document['storageReference']) {
        return document['storageReference'];
    }
    else {
        if (!document.documentRevisions) return null;

        const latestRevision = document.documentRevisions.find((dr) => dr.isActive === true);
        const latestVersion = latestRevision.revisionVersions.sort((a, b) => b.versionNumber - a.versionNumber);
        return latestVersion[0].storageReference;
    }
}

export function checkExpires() {
    const expires = sessionStorage.getItem('expires_time');
    if (expires) {
        const olsDate = new Date(expires);
        const date = new Date();
        if (olsDate < date) {
            return findSasToken();
        }
        else {
            return Promise.resolve();
        }
    }
    else {
        return findSasToken();
    }
}

export function findSasToken() {
    return new Promise((resolve, reject) => {
        getSasToken()
            .then((res) => {
                var expiryDate = new Date();
                var minutes = 100;
                expiryDate.setTime(expiryDate.getTime() + (minutes * 60 * 1000));
                sessionStorage.setItem('sas_token', res);
                sessionStorage.setItem('expires_time', expiryDate.toString());
                resolve(res);
            })
            .catch(reject);
    });
}

export function getSasToken() {
    const baseUrl = store.state.parentAPI;
    return new Promise((resolve, reject) => {
        HttpService.get({
            baseURL: baseUrl,
            url: `document/sas-token`,
        }).then((response) => {
            let token = response.data;
            resolve(token);
        }).catch(reject);
    })
}

export function uploadFilesToFolder(files, folder) {
    const assetId = store.state.assetId;
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("linkedTo", JSON.stringify({ "level": 0, "itemId": store.state.assetId, "recordType": 0 }));
        formData.append("folder", folder);
        formData.append("assetId", assetId);
        files.forEach(file => {
            formData.append(file.name, file);
        });

        UPLOAD_DOCUMENTS(formData)
            .then(attachments => {
                if (!attachments?.length) return;
                store.dispatch('UPDATE_UPLOADED_DOCUMENTS', { ids: attachments.map(a => a.id) });
                resolve(attachments);
            })
            .catch(reject)
    })
}

export function GET_DOCUMENT_TYPES_FORM_PARENT () {
    const baseUrl = store.state.parentAPI;
    return new Promise((resolve, reject) => {
        HttpService.get({
            baseURL: baseUrl,
            url: `document/document-types/forge`,
        }).then((response) => {
            let types = response.data;
            resolve(types);
        }).catch(reject);
    })
}

export function UPLOAD_DOCUMENTS (formData) {
    const baseUrl = store.state.parentAPI;
    return new Promise((resolve, reject) => {
        HttpService.post({
            baseURL: baseUrl,
            url: `document/upload-documents`,
            data: formData,
        }).then((response) => {
            let attachments = response.data;
            resolve(attachments);
        }).catch(reject);
    })
}

export function DELETE_DOCUMENTS(ids) {
    const baseUrl = store.state.parentAPI;

    let data = ids.map(id => {
        return { id };
    })

    return new Promise((resolve, reject) => {
        HttpService.post({
            baseURL: baseUrl,
            url: `document/deletev2`,
            data: data,
        }).then((response) => {
            deleteAttachmentByReferenceIds(ids).then((data) => {
                store.dispatch('RequestPIdsLinkedTags');
                resolve(data);
            }).catch(reject);
            store.dispatch('DELETE_ATTACHMENTS_FROM_DATA', { ids: ids });
        }).catch(reject);
    })
}

export function UPDATE_DOCUMENT(document) {
    const baseUrl = store.state.parentAPI;
    return new Promise((resolve, reject) => {
        HttpService.post({
            baseURL: baseUrl,
            url: `document/update-child`,
            data: document,
        }).then((response) => {
            GET_DOCUMENT_BY_ID(document.id)
                .then(resolve)
                .catch(reject);
        }).catch(reject);
    })
}

export function GET_DOCUMENTS_BY_QUERY(queryParameters) {
    const baseUrl = store.state.parentAPI;
    return new Promise((resolve, reject) => {
        HttpService.get({
            baseURL: baseUrl,
            url: `document/v2/documents?${queryParameters}`,
        }).then((response) => {
            let attachments = response.data;
            resolve(attachments);
        }).catch(reject);
    })
}

export function GET_ALL_DOCUMENTS (query) {
    const baseUrl = store.state.parentAPI;
    const parentBlob = store.state.parentBlob;
    return new Promise((resolve, reject) => {
        HttpService.post({
            baseURL: baseUrl,
            url: `document/documents/forge?${query}`,
        }).then((response) => {
            let attachments = response.data;
            checkExpires().then(_ => {
                let cookieValue = sessionStorage.getItem('sas_token');

                attachments.forEach(a => {
                    a.originalLinkedEquipmentIds = [...(a.equipmentTagIds ?? [])];
                    a.storageReference = a.url.split('/').pop();
                    let url = `${parentBlob}${a.storageReference}?${cookieValue}&domain=reality.com`;
                    a.url = decodeURI(url);
                })

                store.dispatch('UPDATE_DOCUMENTS', { attachments });
                
                store.dispatch('RequestPIdsLinkedTags');

                resolve(attachments);
            })
        }).catch(reject);
    })
}

export function GET_DOCUMENT_BY_ID (id) {
    const baseUrl = store.state.parentAPI;
    const parentBlob = store.state.parentBlob;
    return new Promise((resolve, reject) => {
        HttpService.get({
            baseURL: baseUrl,
            url: `document/documents/forge/${id}`,
        }).then((response) => {
            let document = response.data;
            checkExpires().then( _ => {
                let cookieValue = sessionStorage.getItem('sas_token');
                document.storageReference = document.url.split('/').pop();
                let url = `${parentBlob}${document.storageReference}?${cookieValue}&domain=reality.com`;
                document.url = decodeURI(url);
                resolve(document);
            })
        }).catch(reject);
    })
}

export function deleteAttachmentByReferenceIds(ids) {
    return new Promise((resolve, reject) => {
        HttpService.post({
            url: `api/forge/attachments/deleteAttachmentByReferenceIds`,
            data: { ids },
        }).then(resolve).catch(reject);
    })
}